<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row items-center">
                        Projects
                        <Loader v-if="isProjectsFetchPending" class="h-6 w-6 m-2 border-2 -red -sm"/>
                    </span>
                    <LangSwitcher />
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <div class="m-4">
                <Search
                    v-model="search"
                    @update:modelValue="handleSearchChange"
                />

                <List
                    :items="projects"
                    :columns="columns"
                    :desc="desc"
                    @editItem="handleEditProject"
                    @deleteItem="handleDeleteProject"
                    @manageItem="handleManageProject"
                    @sortBy="handleSortBy"
                    editable
                    deletable
                    manageable
                >
                    <template #actions="actionsProps">
                        <a v-if="actionsProps.item.emerige_id" href="/emerige" class="text-indigo-600 hover:text-indigo-900 px-2" @click.prevent="handleSyncEmerige(actionsProps.item)">Sync. w/ Emerige</a>
                        <a v-if="actionsProps.item.immolead_id" href="/immolead" class="text-indigo-600 hover:text-indigo-900 px-2" @click.prevent="handleSyncEmerige(actionsProps.item)">Sync. w/ Immolead</a>
                        <a v-if="actionsProps.item.adlead_id" href="/adlead" class="text-indigo-600 hover:text-indigo-900 px-2" @click.prevent="handleSyncEmerige(actionsProps.item)">Sync. w/ Adlead</a>
                        <a v-if="actionsProps.item.unlatch_id" href="/unlatch" class="text-indigo-600 hover:text-indigo-900 px-2" @click.prevent="handleSyncEmerige(actionsProps.item)">Sync. w/ Unlatch</a>
                        <a v-if="actionsProps.item.scriba_operation_id" href="/scriba" class="text-indigo-600 hover:text-indigo-900 px-2" @click.prevent="handleSyncEmerige(actionsProps.item)">Sync. w/ Scriba</a>
                    </template>
                </List>

                <Pagination
                    v-if="lastPage > 1"
                    :current_page="currentPage"
                    :last_page="lastPage"
                    @change="handleChangePage"
                />
            </div>
        </div>
    </main>
</template>

<script>
import PageHeader from "../../components/partials/page-header";
import Loader from "../../components/partials/loader";
import Pagination from "../../components/partials/pagination";
import Search from "../../components/partials/search";
import List from "../../components/partials/list";
import LangSwitcher from "../../components/partials/lang-switcher";

export default {
    data() {
        return {
            sort_by: null,
            desc: false,
            search: null,
            delayer: null,
        }
    },
    computed: {
        locale() {
            return this.$store.state.config.locale;
        },
        isProjectsFetchPending() {
            return this.$store.state.projects.isFetchListPending;
        },
        projects() {
            return this.$store.state.projects.list;
        },
        lastPage() {
            return this.$store.state.projects.pagination.last_page
        },
        currentPage() {
            return this.$store.state.projects.pagination.current_page
        },
        columns() {
            return {
                id: {},
                ['translatable.name.' + this.locale]: {
                    sortable: true,
                    sortBy: 'name',
                    label: 'Nom'
                },
                'show_price': {
                    label: 'Afficher prix ?',
                    filter: 'readableBoolean'
                },
                'show_category': {
                    label: 'Afficher catégorie ?',
                    filter: 'readableBoolean'
                }
            }
        },
        auth_user() {
            return this.$store.state.auth.auth_user
        }
    },
    mounted() {
        this.$store.dispatch('projects/getList', {includes: ['domain', 'buildings', 'scribaOperation'], search: this.auth_user.role <= 2 ? {} : {'domain.corporation.id': this.auth_user.corporation.id}});
    },
    methods: {
        handleDeleteProject(project) {
            this.$store.state.projects.single = project;
            this.$store.dispatch('modals/open', 'project-delete');
        },
        handleChangePage(page = this.currentPage) {
            this.$store.dispatch('projects/getList', {
                'page': page,
                'sort_by': this.sort_by,
                'desc': this.desc,
                'search': {'name': this.search}
            });
        },
        handleSortBy(type) {
            this.desc = !this.desc;
            this.sort_by = type;

            this.handleChangePage();
        },
        handleSearchChange(search) {
            this.search = search;
            this.handleChangePage();
        },
        handleCreateProject() {
            this.$store.dispatch('projects/resetSingle')
            this.$store.dispatch('modals/open', 'project-save');
        },
        handleEditProject(project) {
            this.$store.dispatch('projects/setSingle', project);
            this.$store.dispatch('modals/open', 'project-save');
        },
        handleManageProject(project) {
            this.$router.push({name: 'project-show', params: {id: project.id}})

        },
        handleSyncEmerige(project) {
            this.$store.dispatch('projects/syncEmerige', {id: project.id});
        }
    },
    components: {
        PageHeader,
        Loader,
        Pagination,
        Search,
        List,
        LangSwitcher
    }
}
</script>
